module.exports = __webpack_public_path__ + "img/icon_5_62.830896ac.png";